import { FC } from "react";
import { IconProps } from "@chakra-ui/react";
import {
  MensBasicsLogo,
  WomensBasicsLogo,
  WomensBasicsPlusLogo,
  WomensOvulationSupportLogo,
  WomensPregnancySupportLogo,
} from "./components";

export interface ProductConfig {
  name: string;
  slug: string;
  price: string;
  logo: FC<IconProps>;
  color?: string;
}

export const PRODUCT_MAPPING: Record<string, ProductConfig> = {
  mens_basics: {
    name: "Semen Analysis",
    slug: "mens_basics",
    price: "$295",
    logo: MensBasicsLogo,
    color: "teal.600",
  },
  mens_advanced: {
    name: "Men's Advanced",
    slug: "mens_advanced",
    price: "$399",
    logo: WomensBasicsPlusLogo,
    color: "orange.400",
  },
  womens_basics: {
    name: "Women's Basic Fertility Test",
    slug: "womens_basics",
    price: "$175",
    logo: WomensBasicsLogo,
    color: "teal.600",
  },
  womens_advanced: {
    name: "Women's Advanced Fertility Test",
    slug: "womens_advanced",
    price: "$285",
    logo: WomensBasicsPlusLogo,
    color: "orange.400",
  },
  ovulation_support: {
    name: "Ovulation Support",
    slug: "ovulation_support",
    price: "$129",
    logo: WomensOvulationSupportLogo,
    color: "#AEA591"
  },
  pregnancy_support: {
    name: "Pregnancy Support",
    slug: "pregnancy_support",
    price: "$104",
    logo: WomensPregnancySupportLogo,
    color: "yellow.400",
  },
};
